$ = require 'jquery'
ApiAjax = require 'network/api-ajax'
Auth = require 'db/auth'
localizeServerError = require 'lib/localize-server-error'
PopOver = require 'views/lib/pop-over'
Util = require 'lib/util'
View = require 'view'
templates = require 'views/internal/templates'
track = require 'debug/track'
l = require 'lib/localize'

module.exports = class ChangeLogoPopoverView extends View
  viewTitleKey: 'change logo'

  initialize: ->
    @listenTo @model, 'change:logoHash', @frameDebounce @render

  events:
    'change .js-upload-logo': 'startUpload'
    'click .js-remove-logo': 'removeLogo'

  render: ->
    view = @

    data = @model.toJSON(prefs: true)

    @$el.html(
      templates.fill(
        'popover_org_logo',
        data
      )
    )

    @

  startUpload: (e) ->
    model = @model
    input = $(e.target)

    $error = @$('.js-error').hide()

    file = input[0]?.files?[0]
    if file? && !Util.validFileSize(file)
      $error.text(l('images can not be larger than 10mb')).show()
      track("Organization", "Logo", "Upload Error - File Too Large")
      return

    if !file && input.val()
      # IE special-case
      return Util.uploadFile Auth.myToken(), input, @uploadResult.bind(@)

    if !file?
      # No file specified
      return

    # Ajax upload
    fd = new FormData()
    fd.append("token", Auth.myToken())
    fd.append("file", file)

    ApiAjax
      url: input.closest('form').attr('action')
      data: fd
      type: 'post'
      processData: false
      contentType: false
      error: (res) => @uploadResult(new Error(localizeServerError(res)))
      success: => @uploadResult(null, arguments...)
      timeout: 120000

  uploadResult: (err) ->
    $error = @$('.js-error').hide()

    if (err)
      track("Organization", "Logo", "Error - #{err}")
      $error.show().text(err)
    else
      track("Organization", "Logo", "Use Uploaded - New")
      PopOver.hide()

  removeLogo: (e) ->
    Util.stop(e)
    ApiAjax
      url: "/1/organizations/#{ @model.id }/logo"
      type: 'DELETE'
      success: =>
        track("Organization", "Logo", "Remove Logo")
        PopOver.hide()

    return



// WEBPACK FOOTER //
// ./app/scripts/views/organization/change-logo-popover-view.coffee